/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { getMonth } from 'date-fns';
import './NewBooksInMonthFilter.scss';
import { Select } from 'antd';
import { range } from 'lodash';
import { getEntryYears } from './NewBooksInMonthApi';

export const GROUP_TYPES = [
  {
    label: 'Tất cả',
    value: 0,
  },
  {
    label: 'Sách',
    value: 1,
  },
  {
    label: 'Luận văn, luận án',
    value: 2,
  },
  {
    label: 'Ấn phẩm định kỳ',
    value: 3,
  },
  {
    label: 'Bải trích báo',
    value: 4,
  },
];

const getMonths = () =>
  range(0, 12).map((i) => ({ label: `Tháng ${i + 1}`, value: i + 1 }));

function NewBooksInMonthFilter({ onFilterUpdate }) {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelecteYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState(getMonth(new Date()) + 1);
  const [selectedGroup, setSelectedGroup] = useState(GROUP_TYPES[0].value);

  useEffect(() => {
    if (!selectedGroup && !selectedMonth && !selectedYear) {
      return;
    }

    onFilterUpdate({
      groupType: selectedGroup,
      month: selectedMonth,
      year: selectedYear,
    });
  }, [selectedGroup, selectedMonth, selectedYear]);

  useEffect(() => {
    getEntryYears().then((data) => {
      setYears(data);
      if (!data.length) {
        return null;
      }
      setSelecteYear(data[data.length - 1]);
      return () => {};
    });
  }, []);

  useEffect(() => {}, [selectedGroup, selectedMonth, selectedYear]);
  return (
    <div className="new-books-in-month-filter">
      <div className="new-books-in-month-filter__item">
        Loại tài liệu:{' '}
        <Select
          className="new-books-in-month-filter__group-select"
          showSearch
          value={selectedGroup}
          onChange={setSelectedGroup}
        >
          {GROUP_TYPES.map(({ value, label }) => (
            <Select.Option value={value} key={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div className="new-books-in-month-filter__item">
        Tháng:{' '}
        <Select showSearch value={selectedMonth} onChange={setSelectedMonth}>
          {getMonths().map(({ value, label }) => (
            <Select.Option value={value} key={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div className="new-books-in-month-filter__item">
        Năm:{' '}
        <Select showSearch value={selectedYear} onChange={setSelecteYear}>
          {years.map((year) => (
            <Select.Option value={year} key={year}>
              {year}
            </Select.Option>
          ))}
        </Select>
      </div>
    </div>
  );
}

export default NewBooksInMonthFilter;
